<template>
  <k-dialog @close="cancel" :max-height="400" :max-width="400" :title="action">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Client Name :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'clientName'"
              v-model="clientInEdit.clientName"
              class="form-control"
              :required="true"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"> Client ID : </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'clientId'"
              v-model="clientInEdit.clientId"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div
          v-if="!clientInEdit.id"
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
        >
          <label class="col-sm-3 text-left col-form-label">
            Client Secrets :
          </label>
          <div class="col-sm-9">
            <k-input
              :name="'clientSecrets'"
              type="text"
              :placeholder="'Enter comma  seperated values'"
              v-model="clientInEdit.clientSecrets"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allow Access Tokens Via Browser?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.allowAccessTokensViaBrowser"
              :messages="messages"
              v-model="clientInEdit.allowAccessTokensViaBrowser"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Redirect URI :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'redirectUris'"
              :placeholder="'https://website.com/silent-renew-oidc, https://website.com/callback'"
              v-model="clientInEdit.redirectUris"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed CORS Origin :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'allowedCorsOrigins'"
              :placeholder="'https://website.com'"
              v-model="clientInEdit.allowedCorsOrigins"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed Scopes :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="scopeMultiselect"
              :data-source="scopesList"
              v-model="clientInEdit.allowedScopes"
              :placeholder="'Select Scopes...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div
          v-if="!clientInEdit.id"
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
        >
          <label class="col-sm-3 text-left col-form-label">
            Allowed Grant Types :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="grantMultiselect"
              :data-source="grantsList"
              v-model="clientInEdit.allowedGrantTypes"
              :placeholder="'Select Grants...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed Roles :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="roleMultiselect"
              :data-source="rolesList"
              v-model="clientInEdit.allowedRoles"
              :data-text-field="'roleName'"
              :data-value-field="'roleName'"
              :value-primitive="true"
              :placeholder="'Select Roles...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Privileged Roles :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              :data-source="rolesList"
              v-model="clientInEdit.privilegedRoles"
              :data-text-field="'roleName'"
              :data-value-field="'roleName'"
              :value-primitive="true"
              :placeholder="'Select Roles...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Default Roles :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              :data-source="rolesList"
              v-model="clientInEdit.defaultRoles"
              :data-text-field="'roleName'"
              :data-value-field="'roleName'"
              :value-primitive="true"
              :placeholder="'Select Roles...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Post Logout Redirect Uri :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'postLogoutRedirectUris'"
              placeholder="https://website.com/logoutSuccess"
              v-model="clientInEdit.postLogoutRedirectUris"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Always Include User Claims in ID Token?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.alwaysIncludeUserClaimsInIdToken"
              :messages="messages"
              v-model="clientInEdit.alwaysIncludeUserClaimsInIdToken"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Always Send Client Claims?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.alwaysSendClientClaims"
              :messages="messages"
              v-model="clientInEdit.alwaysSendClientClaims"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Require Consent?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.requireConsent"
              :messages="messages"
              v-model="clientInEdit.requireConsent"
            ></kendo-switch>
          </div>
        </div>
          <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is External Registration Allowed?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.isExternalRegAllowed"
              :messages="messages"
              v-model="clientInEdit.isExternalRegAllowed"
              :name="'isExternalRegAllowed'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is Tenant Based?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.isTenantBased"
              :messages="messages"
              v-model="clientInEdit.isTenantBased"
              :name="'isTenantBased'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Send User Mail On Activation?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.sendMailOnUserActivation"
              :messages="messages"
              v-model="clientInEdit.sendMailOnUserActivation"
              :name="'sendMail'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is Custom Authenticaion?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.isCustomAuthentication"
              :messages="messages"
              v-model="clientInEdit.isCustomAuthentication"
              :name="'customAuth'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is Default OTP Login?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.isDefaultOTP"
              :messages="messages"
              v-model="clientInEdit.isDefaultOTP"
              :name="'isTenantBased'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Require Client Secret?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.requireClientSecret"
              :messages="messages"
              v-model="clientInEdit.requireClientSecret"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allow Offline Access?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.allowOfflineAccess"
              :messages="messages"
              v-model="clientInEdit.allowOfflineAccess"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Access Token Lifetime :
          </label>
          <div class="col-sm-9">
            <k-input
              type="number"
              :name="'accessTokenLifetime'"
              :placeholder="'3600'"
              v-model="clientInEdit.accessTokenLifetime"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Refresh Token Lifetime :
          </label>
          <div class="col-sm-9">
            <k-input
              type="number"
              :name="'refreshTokenLifetime'"
              :placeholder="'2592000'"
              v-model="clientInEdit.refreshTokenLifetime"
              class="form-control"
            ></k-input>
          </div>
        </div>
      </div>

      <input type="submit" id="submit-form" class="d-none" />
    </form>
    <div class="d-flex">
      <button class="k-button col-6" @click="cancel">Cancel</button>
      <label
        class="k-button k-primary col-6 mb-0"
        for="submit-form"
        tabindex="0"
        >Save</label
      >
    </div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Input } from "@progress/kendo-vue-inputs";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
import { Switch } from "@progress/kendo-inputs-vue-wrapper";
import { oidcSettings } from "../../services/store";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.switch";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.multiselect";

export default {
  components: {
    "k-input": Input,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-multiselect": MultiSelect,
    "kendo-switch": Switch,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    scopesList: Array,
    grantsList: Array,
    rolesList: Array,
    errors: Array,
  },
  data: function () {
    return {
      clientInEdit: {
        clientName: "",
        clientSecrets: "",
        allowedGrantTypes: [],
        allowAccessTokensViaBrowser: false,
        alwaysIncludeUserClaimsInIdToken: false,
        alwaysSendClientClaims: false,
        requireConsent: false,
        redirectUris: "",
        allowedCorsOrigins: "",
        postLogoutRedirectUris: "",
        allowedScopes: [],
        identityPoolID: "",
        isTenantBased: false,
        allowedRoles: [],
        privilegedRoles: [],
        defaultRoles:[],
        refreshTokenLifetime: 0,
        accessTokenLifetime: 0,
      },
      base_url: undefined,
      action: "",
      multiselectValue: [],
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
    };
  },
  validations: {
    clientInEdit: {},
  },
  created: function () {
    if (this.$props.dataItem) {
      this.clientInEdit = this.$props.dataItem;
      console.log(this.$props.dataItem);
    }
    this.action = this.$props.dialogTitle;
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    // this.getScopesList();
  },
  mounted: function () {
    // if (this.clientInEdit.allowedRoles != undefined) {
    //   var roleMS = this.$refs.roleMultiselect.kendoWidget();
    //   var roles = this.clientInEdit.allowedRoles.map((role) =>
    //     this.$props.rolesList.find((r) => r.roleName == role)
    //   );
    //   roleMS.value(roles);
    //   console.log(roles);
    //   console.log(roleMS.value());
    // }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (
        !(
          Array.isArray(this.clientInEdit.allowedRoles) &&
          this.clientInEdit.allowedRoles.length &&
          Array.isArray(this.clientInEdit.allowedScopes) &&
          this.clientInEdit.allowedScopes.length &&
          Array.isArray(this.clientInEdit.allowedGrantTypes) &&
          this.clientInEdit.allowedGrantTypes.length
        )
      ) {
        if (
          !(
            Array.isArray(this.clientInEdit.allowedRoles) &&
            this.clientInEdit.allowedRoles.length
          )
        ) {
          this.errors.push("Please select Allowed Roles");
        }
        
        // if (
        //   !(
        //     Array.isArray(this.clientInEdit.privilegedRoles) &&
        //     this.clientInEdit.privilegedRoles.length
        //   )
        // ) {
        //   this.errors.push("Please select Privileged Roles");
        // }
        if (
          !(
            Array.isArray(this.clientInEdit.allowedScopes) &&
            this.clientInEdit.allowedScopes.length
          )
        ) {
          this.errors.push("Please select Scopes");
        }

        if (
          !(
            Array.isArray(this.clientInEdit.allowedGrantTypes) &&
            this.clientInEdit.allowedGrantTypes.length
          )
        ) {
          this.errors.push("Please select Grant Types");
        }

        return;
      }
      console.log("SAVED");
      if (this.action == "Edit Client") {
        this.$emit("save");
      } else {
        this.$emit("save");
      }
    },
    corsToArray(val) {
      this.clientInEdit.allowedCorsOrigins = val.split(",");
      console.log(val.split(","));
    },
  },
};
</script>
<style scoped>
.k-widget.k-window.k-dialog {
  overflow: auto;
}
</style>